/**
 * Created by fers on 29.07.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';

interface EntityDefIconProps {
    icon: string;
}

export default class EntityDefIcon extends React.Component<EntityDefIconProps> {
    static propTypes = {
        icon: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        let className = "";

        if (this.props.icon.startsWith("fa-")) {
            className = "fa " + this.props.icon;
        } else {
            className = this.props.icon;
        }

        if (this.props.icon) {
            return (
                <span className={className}/>
            );
        }
    }
}
